import {Component, ChangeDetectionStrategy, Input, HostBinding} from '@angular/core'

@Component({
  selector: 'bgo-hero-cover-title, h1[bgo-hero-cover-title]',
  exportAs: 'cft-hero-cover-title',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content/>',
  styles: `
    @reference '../../../../../styles/theme.css';

    :host {
      @apply before:mb-sm before:h-4 before:w-4 before:bg-red-500 before:content-[''];
      @apply md:before:absolute md:before:top-sm md:before:mb-0 md:before:-translate-x-8;
      @apply relative flex flex-col md:flex-row;
      @apply text-white;
      @apply text-2xl font-bold;
      @apply drop-shadow-3;
      @apply max-w-(--container-lg);
    }
    :host(.small) {
      @apply md:before:top-[0.6rem];
      @apply text-xl;
    }
  `,
})
export class HeroCoverTitleComponent {
  @Input()
  @HostBinding('class')
  size: TitleSize = 'large'
}

type TitleSize = 'small' | 'large'
